import React from 'react';
import {FaAngleRight, FaTimes,} from "react-icons/fa";
import VehicleDetails from "./details/vehicle-details.jsx";
import IndividualDetails from "./details/individual-details.jsx";
import EncounterDetails from "./details/encounter-details.jsx";
import BoDetails from "./details/bo-details.jsx";
import OccurrenceDetails from "./details/occurrence-details.jsx";
import SosDetails from "./details/sos-details.jsx";
import CoincidentPassagesDetails from "./details/coincident-passages-details.jsx";
import PassageDetails from "./details/passage-details.jsx";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import {Types} from "../enums.js";
import AnnotationDetails from "./details/annotation-details.jsx";
import SocialMediaDetails from "./details/social-media-details.jsx";
import ImageDetails from "./details/image-details.jsx";
import CompanyDetails from "./details/company-details.jsx";
import NewsDetails from "./details/news-details.jsx";

const bodyColor = {
    individual: "bg-[#f5fff9]",
    encounter: "bg-[#e0f0f6]",
    bo: "bg-[#f5f5f5]",
    occurrence: "bg-[#f5fff9]",
    sos: "bg-[#fffcef]",
    vehicle: "bg-[#eeeeee]",
    passage: "bg-[#ffffff]",
    company: "bg-[#d1d7e3]",
    social_media: "bg-[#ffe8e8]",
    news: "bg-[#fff9d7]",
    image: "bg-[#eadcea]",
    annotation: "bg-[#ffffff]",
}

const Details = ({show}) => {
    const {selectedNode, setSelectedNode, setPanelOpened} = useEdgeBuilder()

    const close = () => {
        setPanelOpened(null)
        setSelectedNode(null)
    }
    return (
        <>
            {
                show &&
                <div onClick={close} style={{right: "-25px"}}
                     className="absolute w-screen h-screen right-0 top-[-15px] bg-[#7b7b7b24]"></div>
            }

            <div
                className={`absolute top-0 rounded-[5px]  shadow-lg z-50 ${show ? "translate-x-0 right-0" : "translate-x-full right-[-30px]"}
                ${bodyColor[selectedNode?.type] ?? "bg-white"}  
                transform transition-transform duration-300 ease-in-out w-[300px]`}>
                <div>
                    <div onClick={close}
                         className={"p-[10px] cursor-pointer"}>
                        <FaAngleRight color={"#a3a3a3"} size={18}/>
                    </div>
                    <div className={""}>
                        {selectedNode?.type === Types.VEHICLE && <VehicleDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.INDIVIDUAL && <IndividualDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.ENCOUNTER && <EncounterDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.BO && <BoDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.OCCURRENCE && <OccurrenceDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.SOS && <SosDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.COINCIDENT_PASSAGES && <CoincidentPassagesDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.PASSAGE && <PassageDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.ANNOTATION && <AnnotationDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.SOCIAL_MEDIA && <SocialMediaDetails data={selectedNode?.data}/>}
                        {selectedNode?.type === Types.IMAGE && <ImageDetails data={selectedNode?.data} nodeId={selectedNode?.id}/>}
                        {selectedNode?.type === Types.COMPANY && <CompanyDetails data={selectedNode?.data} />}
                        {selectedNode?.type === Types.NEWS && <NewsDetails data={selectedNode?.data} />}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Details;